import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import {
  mdiAccountGroup,
  mdiAlert,
  mdiArrowLeft,
  mdiCheck,
  mdiCheckCircle,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiChevronDown,
  mdiChevronLeft,
  mdiCircleOutline,
  mdiClose,
  mdiCloseCircle,
  mdiDotsHorizontal,
  mdiEye,
  mdiEyeOff,
  mdiFlashCircle,
  mdiHelpCircleOutline,
  mdiInformationOutline,
  mdiLoading,
  mdiMagnify,
  mdiPlay,
} from '@mdi/js';
import styled from 'styled-components';

const sizes = {
  medium: '32px',
  small: '24px',
  tiny: '16px',
};

const Container = styled(Icon)`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  margin: 0 6px 0 0;

  .dropdown--table-row & {
    margin: 0;
  }
`;

const I = ({ name, size, ...props }) => {
  const iconSize = typeof size === 'number' ? `${size}px` : sizes[size];

  return (
    <Container
      path={name}
      size={iconSize}
      color="var(--cc_color_button_text_subtle)"
      {...props}
    />
  );
  // available props https://dev.materialdesignicons.com/getting-started/react#props
};

/**
 * @deprecated use `<i className="mdi mdi-arrow-left" />` instead
 */

export const ArrowLeft = (props) => <I name={mdiArrowLeft} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-account-group" />` instead
 */

export const AccountGroupIcon = (props) => (
  <I name={mdiAccountGroup} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-check" />` instead
 */

export const CheckIcon = (props) => <I name={mdiCheck} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-check-circle" />` instead
 */

export const CheckCircle = (props) => <I name={mdiCheckCircle} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-checkbox-marked" />` instead
 */

export const CheckboxMarked = (props) => (
  <I name={mdiCheckboxMarked} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-checkbox-blank-outline" />` instead
 */

export const CheckboxBlank = (props) => (
  <I name={mdiCheckboxBlankOutline} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-chevron-down" />` instead
 */

export const ChevronDown = (props) => <I name={mdiChevronDown} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-circle-outline" />` instead
 */

export const CircleOutline = (props) => (
  <I name={mdiCircleOutline} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-close-circle"" />` instead
 */

export const CloseCircle = (props) => <I name={mdiCloseCircle} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-lightning-bolt-circle" />` instead
 */

export const FlashCircle = (props) => <I name={mdiFlashCircle} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-eye-off" />` instead
 */

export const HiddenIcon = (props) => <I name={mdiEyeOff} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-eye" />` instead
 */

export const ShowIcon = (props) => <I name={mdiEye} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-information-outline" />` instead
 */

export const InformationOutlineIcon = (props) => (
  <I name={mdiInformationOutline} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-loading" />` instead
 */

export const LoadingIcon = (props) => (
  <I
    name={mdiLoading}
    color="var(--cc_color_link_primary)"
    size="medium"
    spin={1}
    {...props}
  />
);

/**
 * @deprecated use `<i className="mdi mdi-chevron-left" />` instead
 */

export const BackIcon = (props) => <I name={mdiChevronLeft} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-dots-horizontal" />` instead
 */

export const MoreIcon = (props) => <I name={mdiDotsHorizontal} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-play" />` instead
 */

export const PlayIcon = (props) => (
  <I style={{ margin: 0 }} name={mdiPlay} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-help-circle-outline" />` instead
 */

export const QuestionOutlineIcon = (props) => (
  <I name={mdiHelpCircleOutline} {...props} />
);

/**
 * @deprecated use `<i className="mdi mdi-alert" />` instead
 */

export const AlertIcon = (props) => <I name={mdiAlert} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-magnify" />` instead
 */

export const SearchIcon = (props) => <I name={mdiMagnify} {...props} />;

/**
 * @deprecated use `<i className="mdi mdi-close" />` instead
 */

export const CloseIcon = (props) => <I name={mdiClose} {...props} />;

I.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

I.defaultProps = {
  name: '',
  size: 'tiny',
};
